import { KeyboardArrowLeft } from '@mui/icons-material'
import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { NavLink, useParams, useNavigate } from 'react-router-dom'
import { usePricePlan } from '../store/PricePlanContext'
import { PRICE_PLAN_URL } from '../config/siteUrls'

// Map URL term to plan display name (same as HelpMe – ensures plan is passed when user clicks Yes)
const getPlanNameFromTerm = (term) => {
  if (!term) return ''
  const map = {
    'special': 'Special Occasions',
    'short-term': 'Short Term',
    'mid-term': 'Mid Term',
    'long-term': 'Long Term',
    'coupon': 'Coupon'
  }
  return map[term] || term
}

const HelpWithCoupons = () => {

  const params = useParams()
  const navigate = useNavigate()
  const { selectedPlan, selectPlanForTerm, pricingData } = usePricePlan()

  const [term, setTerm] = useState("")

  useEffect(() => {
    setTerm(params.term)
  }, [params])

  useEffect(() => {
    selectPlanForTerm(params.term)
  }, [params.term, pricingData])

  // Clear affiliate code from localStorage when user clicks Yes; pass selected plan to form via state
  const handleYesClick = () => {
    const planName = (selectedPlan?.name && selectedPlan.name.trim()) || getPlanNameFromTerm(params.term)
    navigate(`/advertise/${term}/help-me`, { state: { planName } })
  }

  // console.log(params.term)

  return (
    <div className="yes-no-container">
      <div className="yes-no-left">
        <div className="yes-no">
          <p><strong>Need help</strong> creating the coupon?</p>
          <div className="btn-wrapper">
            <div className="blue-btn button">
              <Button onClick={handleYesClick}>YES</Button>
            </div>
            <div className="blue-border-btn button">
              <NavLink to={`/advertise/coupon/${params.term}/create-coupon/1?edit=false`}>
                <Button>NO</Button>
              </NavLink>
            </div>
          </div>
          {/* <p>Lorem ipsum dolor sit amet.</p> */}
        </div>
      </div>
      <div className="yes-no-right"></div>
      <div className="logo-home"></div>
      <div className="back-link-container">
        <a href={PRICE_PLAN_URL} className="back-btn-wizard">
          <Button component="span" style={{ marginBottom: 0 }}>
            <KeyboardArrowLeft /> BACK
          </Button>
        </a>
      </div>
    </div>
  )
}

export default HelpWithCoupons